// extracted by mini-css-extract-plugin
export default {"list":"playlistAlbum_list__Unpwi","cover_photo":"playlistAlbum_cover_photo__Z2Fpa","details":"playlistAlbum_details__8qyMm","dark_cover":"playlistAlbum_dark_cover__UF3kC"};